import DescriptionTwoToneIcon from "@material-ui/icons/DescriptionTwoTone";
import PeopleOutlineTwoToneIcon from "@material-ui/icons/PeopleOutlineTwoTone";
import ListAltTwoToneIcon from "@material-ui/icons/ListAltTwoTone";

export default function navConfig() {
  return [
    {
      subheader: "Presupuestos",
      items: [
        {
          title: "Nuevo Presupuesto",
          icon: DescriptionTwoToneIcon,
          href: "/nuevo-presupuesto",
        },
        {
          title: "Ver Presupuestos",
          icon: ListAltTwoToneIcon,
          href: "/lista-presupuesto",
        },
      ],
    },
    {
      subheader: "Clientes",
      items: [
        {
          title: "Clientes",
          icon: PeopleOutlineTwoToneIcon,
          href: "/lista-clientes",
        },
      ],
    },
  ];
}
